<template>
  
  <v-container fluid grid-list-lg>
    <v-layout row align-center>
      <v-flex class="text-xs-center">
        <h1>Forgot Your Password!</h1>
      </v-flex>
    </v-layout>

    <template v-if="!thanks">
      <v-layout row justify-center align-center>
        <v-flex xs12 md6 shrink style="min-height: 38px;" class="text-xs-center">
          <span>Enter the email address with your account and we'll send you a link to reset your password</span>
        </v-flex>
      </v-layout>

      <v-layout row align-center wrap my-2>
        <v-flex xs12 md6 lg4 offset-md3 offset-lg4>
          <div class="field-label">Email</div>
          <v-text-field
            v-model="email"
            placeholder="Email"
            solo
            flat
            hide-details
            @keydown="checkKeyup"
            :disabled="resetting"
          ></v-text-field>
        </v-flex>
        
        <v-flex xs12 mb-2 mt-4 class="text-xs-center">
          <v-btn color="primary" @click="resetPassword" style="min-width: 150px;" :loading="resetting">SUBMIT</v-btn>
        </v-flex>
        
      </v-layout>

      <v-layout row>
        <v-flex xs12 class="text-xs-center">
          <span class="body-1"><router-link :to="{name: 'auth'}">Back to Login</router-link></span>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-layout row justify-center align-center wrap class="mt-4">
        <v-flex xs12 md6 shrink style="min-height: 30px;" class="text-xs-center">
          <div>Thank you! The instructions have been sent to your email</div>
          <div class="mt-3">If you don't receive instructions within a few minutes, check your email's spam and junk filters</div>
          <div class="mt-3">Still having trouble? <a href="mailto:support@trvlporter.com">Contact Us</a></div>
        </v-flex>
        <v-flex xs12 mt-4 class="text-xs-center">
          <v-btn color="primary" :to="{name: 'auth'}" style="min-width: 150px;">Back to Login</v-btn>
        </v-flex>
      </v-layout>
    </template>

  </v-container>

</template>

<script>

export default {
  name: 'ForgotPassword',
  data () {
    return {
      resetting: false,
      email: null,
      thanks: false,
    }
  },
  computed: {
  },
  methods: {
    resetPassword: function() {
      if(!this.email) {
        this.$swal.fire('Email Required', 'You must enter your email address');
        return;
      }

      this.resetting = true;
      
      this.$http.post('auth/forgot-password', {email: this.email})
        .then(response => {
          this.thanks = true;
          this.email = null;
        })
        .catch(error => {
          this.$swal.fire('Error', error.response.data.message);
        })
        .finally( () => {
          this.resetting = false;
        })
    },
    checkKeyup: function(e) {
      if(e.key == 'Enter') this.resetPassword();
    }
  }
}
</script>
